import React from 'react';
import styled from 'styled-components';
import { Button, MessagePlugin } from 'tdesign-react';
import { DownloadIcon } from 'tdesign-icons-react';
import { connect } from 'react-redux';
import BuriedWrapper from '@/components/BuriedWrapper';
import { isVoid } from '@/utils/common';
import Markdown from '../../components/Markdown';

function Download({ url, eventId }) {
  const openPage = () => {
    if (isVoid(url)) {
      MessagePlugin.warning('链接未配置');
      return;
    }
    window.open(url);
  };
  return (
    <BuriedWrapper eventId={eventId}>
      <Button theme='primary' icon={<DownloadIcon />} onClick={openPage}>
        下载 示例代码
      </Button>
    </BuriedWrapper>
  );
}

function Brief({ currentTag, exampleUrls }) {
  const { JAVA, SPRINGBOOT } = exampleUrls || {};
  const contentJava = `
使用Java客户端需要 Java 8 或更高版本。
建议使用 [Eclipse Temurin OpenJDK](https://adoptium.net/zh-CN/temurin/releases/)
  `;

  const contentSpringBoot = `
使用Spring Boot与Pulsar集成需要 Java 17 或更高版本，Spring Boot需要 3.0.x
或更高版本。具体使用可参考
[官方文档](https://docs.spring.io/spring-pulsar/reference/reference/pulsar.html)
`;

  return (
    <Root>
      <Header>
        <Title>{currentTag} 代码示例</Title>
        {currentTag === 'Java' && <Download url={JAVA} eventId='DEV_JAVA_DOWNLOAD_EXAMPLE' />}
        {currentTag === 'Spring Boot' && (
          <Download url={SPRINGBOOT} eventId='DEV_SPRING_BOOT_DOWNLOAD_EXAMPLE' />
        )}
      </Header>
      <SubTitle>
        {currentTag === 'Java' && <Markdown content={contentJava} />}
        {currentTag === 'Spring Boot' && <Markdown content={contentSpringBoot} />}
      </SubTitle>
    </Root>
  );
}

export default connect((state) => ({
  exampleUrls: state.codeSample.exampleUrls,
}))(Brief);

const Root = styled.div``;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Title = styled.div`
  font-size: 22px;
  font-weight: 600;
  line-height: 31px;
  color: #0d111a;
  flex: 1;
`;

const SubTitle = styled.div`
  margin-top: 10px;
  color: #9ba2ae;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
`;
